<template>
  <v-flex class="modal" :class="{ 'h-100':isButtonsFixed }" v-on:keyup.enter="enterButtonHandler">
    <v-flex v-if="isHeaderVisible" class="modal-headline">
      <slot name="headline"></slot>
    </v-flex>
    <v-flex class="content" :class="{ 'full-width': fullWidthContent, 'scrollable-content':isButtonsFixed }">
      <slot></slot>
    </v-flex>
    <v-flex v-if="isButtonsVisible" :class="isButtonsFixed ? 'buttons-wrapper fixed-buttons' : 'buttons-wrapper'">
      <v-layout align-center justify-end row fill-height>
        <v-flex shrink d-flex align-center>
          <slot name="buttons"></slot>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-flex>
</template>
<script>
export default {
  props: {
    isHeaderVisible: {
      type: Boolean,
      default: true
    },
    isButtonsVisible: {
      type: Boolean,
      default: true
    },
    fullWidthContent: {
      type: Boolean,
      default: false
    },
    enterButtonHandler: {
      type: Function,
      default: () => {
        console.log('enter pressed');
        return null;
      }
    },
    isButtonsFixed: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    changeRatingTo(rating) {
      this.ratingPositive = rating;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  overflow: hidden;
  background-color: #ffffff;
  border-bottom-left-radius: 40px;
  position: relative;
  align-items: center;

  .modal-headline {
    color: var(--v-blueGrey-base);
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    padding: 20px;
  }

  .content {
    padding: 0 20px;
    &.full-width {
      padding: 0;
    }
  }
  .buttons-wrapper {
    height: 72px;
    padding: 0 20px;
    background-color: var(--v-bg-base);
    button {
      margin-left: 20px;
    }
  }
  .fixed-buttons{
    position: fixed;
    border-bottom-left-radius: 40px;
    max-width: 450px;
    width: 100%;
    bottom: 10px;
  }
  .scrollable-content{
    overflow-y: scroll;
    height: 100%;
    padding-bottom: 100px !important;
  }
}
</style>
